<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">Murder on the Orion Express</span></p>
<p class="p0">By Gareth Vaughn</p>
<p class="p2"><a id="a3"></a> </p>
<p class="p2"><a href="#/006#a41">Part 1: The Facts</a></p>
<p class="p4"><a href="#/006#a42">Chapter 1: An Important Event at the Hjerson University</a></p>
<p class="p4"><a href="#/007#a43">Chapter 2: The Orion Express</a></p>
<p class="p4"><a href="#/008#a44">Chapter 3: Hercula Refuses to Mingle</a></p>
<p class="p4"><span href="#/009#a45" title="Link target outside of Sample">Chapter 4: The Disturbances in the Night</span></p>
<p class="p4"><span href="#/010#a46" title="Link target outside of Sample">Chapter 5: Suicide</span></p>
<p class="p4"><span href="#/011#a47" title="Link target outside of Sample">Chapter 6: Really Suicide?</span></p>
<p class="p4"><span href="#/012#a48" title="Link target outside of Sample">Chapter 7: The Deceased</span></p>
<p class="p4"><span href="#/013#a49" title="Link target outside of Sample">Chapter 8: The Whealtech Selfdrive Cars Suit</span></p>
<p class="p2"><span href="#/014#a50" title="Link target outside of Sample">Part 2: The Evidence</span></p>
<p class="p4"><span href="#/014#a51" title="Link target outside of Sample">Chapter 1: The Evidence of the Threat</span></p>
<p class="p4"><span href="#/015#a52" title="Link target outside of Sample">Chapter 2: The Evidence of the Audio Media Specialist</span></p>
<p class="p4"><span href="#/016#a53" title="Link target outside of Sample">Chapter 3: The Evidence of the Aunt</span></p>
<p class="p4"><span href="#/017#a54" title="Link target outside of Sample">Chapter 4: The Evidence of the CEO</span></p>
<p class="p4"><span href="#/018#a55" title="Link target outside of Sample">Chapter 5: The Evidence of the Night Shift</span></p>
<p class="p4"><span href="#/019#a56" title="Link target outside of Sample">Chapter 6: The Evidence of the Turned Room</span></p>
<p class="p4"><span href="#/020#a57" title="Link target outside of Sample">Chapter 7: The Evidence of the Tour Guide</span></p>
<p class="p4"><span href="#/021#a58" title="Link target outside of Sample">Chapter 8: The Evidence of the Barista</span></p>
<p class="p4"><span href="#/022#a59" title="Link target outside of Sample">Chapter 9: The Evidence of the DMV Worker</span></p>
<p class="p4"><span href="#/023#a60" title="Link target outside of Sample">Chapter 10: The Evidence of the Captain</span></p>
<p class="p4"><span href="#/024#a61" title="Link target outside of Sample">Chapter 11: The Evidence of the Widow</span></p>
<p class="p4"><span href="#/025#a62" title="Link target outside of Sample">Chapter 12: The Evidence of the Oil Executive</span></p>
<p class="p4"><span href="#/026#a63" title="Link target outside of Sample">Chapter 13: The Evidence of the Nonprofit Director</span></p>
<p class="p4"><span href="#/027#a64" title="Link target outside of Sample">Chapter 14: The Summary of the Evidence</span></p>
<p class="p4"><span href="#/028#a65" title="Link target outside of Sample">Chapter 15: The Evidence of the Returned Data</span></p>
<p class="p2"><span href="#/029#a66" title="Link target outside of Sample">Part 3: Hercula Perry Sits Back and Drinks</span></p>
<p class="p4"><span href="#/029#a67" title="Link target outside of Sample">Chapter 1: Who Could Have Done It?</span></p>
<p class="p4"><span href="#/030#a68" title="Link target outside of Sample">Chapter 2: Terren’s Questions</span></p>
<p class="p4"><span href="#/031#a69" title="Link target outside of Sample">Chapter 3: Certain Deceased People</span></p>
<p class="p4"><span href="#/032#a70" title="Link target outside of Sample">Chapter 4: The Generosity of the Thief</span></p>
<p class="p4"><span href="#/033#a71" title="Link target outside of Sample">Chapter 5: The Identity of the Tenth Person</span></p>
<p class="p4"><span href="#/034#a72" title="Link target outside of Sample">Chapter 6: Simon’s Surprising Revelation</span></p>
<p class="p4"><span href="#/035#a73" title="Link target outside of Sample">Chapter 7: Hercula Proposes Two Possibilities</span></p>
<p class="p4"><span href="#/036#a74" title="Link target outside of Sample">Chapter 8: The Orion Express, Again</span><a href="#/#a40"></a></p>
<h1 class="h10"><a id="ncx58"></a><a id="a40"></a> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?324aa9bc